import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Página não encontrada',
    body: 'Esse endereço não existe.',
    backLink: 'Voltar à visão geral',
  },
  configWarning: {
    body: '<0>Configuração incompleta.</0> Falta {{missing}}. Define-o em <1>.env.local</1> para desenvolvimento local (vê <2>.env.example</2>), ou no ambiente do contentor para uma implementação.',
  },
  skipToContent: 'Saltar para o conteúdo',
  brandName: 'NOLATR',
  mainNav: 'Principal',
  sectionNav: 'Secção',
  accountNav: 'Conta',
  openMainMenu: 'Abrir menu',
  closeMainMenu: 'Fechar menu',
  activeCompany: 'Empresa ativa',
  profileStub: {
    title: 'Perfil',
    lead: 'A tua página de perfil está a caminho — por agora isto é um marcador de posição para que a aplicação tenha para onde te enviar.',
  },
  manageStub: {
    title: 'Gerir',
    lead: 'Escolhe uma secção no menu.',
  },
};
